import React from 'react';

import { ToastContext } from '../ToastProvider';

/**
 * Wraps a component and provides toast functionality through provider
 * @param {React.Component} ComposedComponent -
 * The wrapped component that is provided toast funcationality
 * @returns {React.Component} - HOC
 */
export const withToast = ComposedComponent => props => (
  <ToastContext.Consumer>
    {toast => <ComposedComponent {...props} {...toast} />}
  </ToastContext.Consumer>
);

export default withToast;
